import { MetricsService } from '../services/metrics.ts';

type Subscriber = (data: any) => void;

export class MetricsDataController {
    private static instance: MetricsDataController;
    private metricsService = MetricsService.getInstance();
    private subscribers: Set<Subscriber> = new Set();
    
    private currentOrgId: string | null = null;
    private currentRange: string = '5m';
    private currentStart?: number;
    private currentEnd?: number;

    private cachedData: any = null;
    private isFetching: boolean = false;
    private pollingInterval: any = null;

    private constructor() {}

    public static getInstance(): MetricsDataController {
        if (!MetricsDataController.instance) {
            MetricsDataController.instance = new MetricsDataController();
        }
        return MetricsDataController.instance;
    }

    public subscribe(callback: Subscriber) {
        this.subscribers.add(callback);
        // Immediately notify new subscriber if we have data
        if (this.cachedData) {
            callback(this.cachedData);
        }
        return () => this.subscribers.delete(callback);
    }

    private notify() {
        for (const sub of this.subscribers) {
            try {
                sub(this.cachedData);
            } catch (e) {
                console.error('[MetricsDataController] Error notifying subscriber:', e);
            }
        }
    }

    public setParams(orgId: string, range: string, start?: number, end?: number) {
        let changed = false;
        if (this.currentOrgId !== orgId) { this.currentOrgId = orgId; changed = true; }
        if (this.currentRange !== range) { this.currentRange = range; changed = true; }
        if (this.currentStart !== start) { this.currentStart = start; changed = true; }
        if (this.currentEnd !== end) { this.currentEnd = end; changed = true; }
        
        if (changed) {
            this.fetchData();
        }
    }

    public startPolling(intervalMs: number = 30000) {
        this.stopPolling();
        this.pollingInterval = setInterval(() => this.fetchData(), intervalMs);
    }

    public stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    public async fetchData() {
        if (!this.currentOrgId || this.isFetching) return;
        this.isFetching = true;

        try {
            console.debug(`[MetricsDataController] Fetching summary metrics for org: ${this.currentOrgId}, range: ${this.currentRange}`);
            const data = await this.metricsService.getMetric('summary', this.currentOrgId, this.currentRange, this.currentStart, this.currentEnd);
            
            if (data) {
                this.cachedData = data;
                this.notify();
            }
        } catch (e) {
            console.error('[MetricsDataController] Fetch failed:', e);
        } finally {
            this.isFetching = false;
        }
    }
    
    public getCachedData() {
        return this.cachedData;
    }
}
